import * as LucideIcons from "lucide-react";

export type LucideIconName = keyof typeof LucideIcons;

interface Props {
  name: LucideIconName;
  size?: number;
  className?: string;
}

export const LucideIcon: React.FC<Props> = ({ name, className }) => {
  const LucideIconComp = LucideIcons[name];
  if (!LucideIconComp) {
    return <LucideIcons.CircleDashed className={className} />;
  }
  // @ts-ignore
  return <LucideIconComp className={className} />;
};
